import React from 'react';
import { Tooltip } from '@material-ui/core';
import {
  Container,
  ABwrapper,
  ABstatistics,
  ResendStats,
  ArrowUpIcon,
  Line,
  Column,
  Row,
  Resend,
  ArrowUpIconSmall,
  ArrowDownIconSmall,
  ArrowDownIcon,
  Title,
  Statistics,
  Divider,
  EmptySpace,
  AverageStats,
} from '../../../Component/Analytics/Components/MessageAnalyticsABversion/Components/CardABversion.styled';
import { EmailOnly, TitleRow } from './StatCard';

// Copied from isNotZero in CardABversion.js.
const isNotZero = value =>
  value !== '' &&
  value !== '0%' &&
  value !== '0.0%' &&
  value !== 0 &&
  value !== null &&
  !String(value).includes('NaN%');

const isIncrease = value => value && !String(value).startsWith('-');

// The resend line under the average, as CardABversion.js writes it.
const AverageResendLine = ({ resend }) => {
  const { average, count, isComparative } = resend;
  if (!isNotZero(average)) return 'no change from resend';
  if (!isComparative) {
    return (
      <>
        Resend: {average} ({count})
      </>
    );
  }
  if (isIncrease(average)) {
    return (
      <>
        <ArrowUpIcon />+{average} from resend ({count})
      </>
    );
  }
  return (
    <>
      <ArrowDownIcon />
      {average} from resend
    </>
  );
};

// The resend line under one version's numbers.
const VersionResendLine = ({ value, isComparative }) => {
  if (!isNotZero(value)) return '- no change';
  if (!isComparative) return <>Resend: {value || '0.0%'}</>;
  return isIncrease(value) ? (
    <>
      <ArrowUpIconSmall /> {value}
    </>
  ) : (
    <>
      <ArrowDownIconSmall /> {value}
    </>
  );
};

// An A/B tile, laid out as the current page's CardABversion.js.
// Props as StatCard.
const StatCardAB = ({
  tile,
  Icon,
  isSmallValue,
  isEmailOnly,
  onClick,
  graphToggle,
}) => {
  const { name, tooltip, noDataText, value, count, a, b, resend } = tile;
  const showVersionResend =
    resend && (isNotZero(resend.a) || isNotZero(resend.b));

  return (
    <Tooltip title={tooltip} placement="top">
      <Container onClick={onClick}>
        <TitleRow>
          <div>
            <Title>{name}</Title>
            {isEmailOnly && <EmailOnly>Email only</EmailOnly>}
          </div>
          {graphToggle}
        </TitleRow>
        <Row>
          <Icon />
          <Statistics fontSize={isSmallValue ? '20px' : '34px'}>
            {noDataText || value}
          </Statistics>
          <AverageStats>{noDataText ? null : count}</AverageStats>
        </Row>
        {resend && (
          <ResendStats>
            <AverageResendLine resend={resend} />
          </ResendStats>
        )}
        {noDataText ? (
          <EmptySpace />
        ) : (
          <>
            <Line />
            <ABwrapper>
              <Row>
                <Column>
                  <ABstatistics>
                    A: {a.value || '0.0%'} ({a.count})
                  </ABstatistics>
                  {showVersionResend && (
                    <Resend>
                      <VersionResendLine
                        value={resend.a}
                        isComparative={resend.isComparative}
                      />
                    </Resend>
                  )}
                </Column>
                <Divider />
                <Column>
                  <ABstatistics>
                    B: {b.value || '0.0%'} ({b.count})
                  </ABstatistics>
                  {showVersionResend && (
                    <Resend>
                      <VersionResendLine
                        value={resend.b}
                        isComparative={resend.isComparative}
                      />
                    </Resend>
                  )}
                </Column>
              </Row>
            </ABwrapper>
          </>
        )}
      </Container>
    </Tooltip>
  );
};

export default StatCardAB;
